// extracted by mini-css-extract-plugin
export default {"input":"Search_input__PXR0c","searchBtn":"Search_searchBtn__kEs6t"};